import React from "react";
import "./contact.css";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { email, clock, phone } from "./imports";

const Contact = () => {
  return (
    <div class="contact-page-sec" id="contact">
      <div className="pt__footer-heading">
        <h1 className="gradient__text">
          Are you interested in doing business with us?
        </h1>
      </div>

      <div className="pt__footer-btn">
        <p>Contact us</p>
      </div>
      <div class="container">
        <div class="row1">
          <div class="col-md-4">
            <div class="contact-info">
              <div class="contact-info-item">
                <div class="contact-info-icon">
                  {/* <i class="fas fa-map-marked"></i> */}
                  <img src={phone} alt="address" />
                </div>
                <div class="contact-info-text">
                  <h2>WhatsApp</h2>
                  <a target="_blank" href="https://wa.me/+233538574403">
                    <span>+233538574403 </span>
                  </a>
                  {/* <span>+233547759525</span>  */}
                  <span>-------------</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="contact-info">
              <div class="contact-info-item">
                <div class="contact-info-icon">
                  {/* <i class="fas fa-envelope"></i> */}
                  <img src={email} alt="email" />
                </div>
                <div class="contact-info-text">
                  <h2>E-mail</h2>
                  <a target="_blank" href="mailto:persbetech@gmail.com">
                    <span>persbetech@gmail.com</span>
                  </a>
                  {/* <span>+233547759525</span>  */}
                  <span>-------------</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="contact-info">
              <div class="contact-info-item">
                <div class="contact-info-icon">
                  {/* <i class="fas fa-clock"></i> */}
                  <img src={clock} alt="office-hours" />
                </div>
                <div class="contact-info-text">
                  <h2>office time</h2>
                  <span>Mon - Saturday </span>
                  <span>7:00 am - 5:00 pm</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row2">
          <div class="col-md-4">
            <div class="contact-page-map">
              {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15882.139148754528!2d-0.0898326!3d5.635461!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5a6e0ff575b3c44d!2sPersbe%20Tech!5e0!3m2!1sen!2sgh!4v1657710683018!5m2!1sen!2sgh" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
              <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15882.139148754528!2d-0.0898326!3d5.635461!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5a6e0ff575b3c44d!2sPersbe%20Tech!5e0!3m2!1sen!2sgh!4v1657710683018!5m2!1sen!2sgh"
                width="100%"
                height="450"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
